// Shared labels for Codebase Guide (Repo Playbook) entries.
export const CODEBASE_GUIDE_CATEGORIES = [
  { value: "product_context", label: "Product context" },
  { value: "architecture", label: "Architecture" },
  { value: "test_commands", label: "Test commands" },
  { value: "do_not_touch", label: "Do not touch" },
  { value: "auth_security", label: "Auth & security" },
  { value: "review_checklist", label: "Review checklist" },
  { value: "freelancer_guidance", label: "Freelancer guidance" },
  { value: "deployment", label: "Deployment" },
  { value: "style_conventions", label: "Style & conventions" },
  { value: "data_model", label: "Data model" },
  { value: "integration", label: "Integrations" },
  { value: "other", label: "Other" },
];

export const CODEBASE_GUIDE_PRIORITIES = [
  { value: "critical", label: "Critical" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export function guideCategoryLabel(value) {
  return CODEBASE_GUIDE_CATEGORIES.find((c) => c.value === value)?.label || value;
}

export function guidePriorityLabel(value) {
  return CODEBASE_GUIDE_PRIORITIES.find((p) => p.value === value)?.label || value;
}
